import { createHashRouter, createRoutesFromElements, Navigate, Route } from 'react-router-dom';

import AppLayout from '../layout/AppLayout';
import RoutingErrorPage from '../pages/RoutingErrorPage';
import { RoutingErrorElement } from './RoutingErrorElement';
import { routes } from './routes';
import { suspendPageLoad } from './suspendPageLoad';

// Lazy load pages for better performance and automatically split the bundle accordingly
const StreamsOverviewPage = suspendPageLoad(() => import('../pages/StreamsOverviewPage'));
const StreamDetailsPage = suspendPageLoad(() => import('../pages/StreamDetailsPage'));
const MonitorsOverviewPage = suspendPageLoad(() => import('../pages/MonitorsOverviewPage'));
const MonitorsDetailPage = suspendPageLoad(() => import('../pages/MonitorsDetailPage'));

const routesFromElements = createRoutesFromElements(
    <Route element={<AppLayout />} errorElement={<RoutingErrorElement />}>
        <Route path={routes.ERROR} element={<RoutingErrorPage />} />

        <Route path='/' element={<Navigate to={routes.STREAMS} replace />} />
        <Route path={routes.STREAMS} element={<StreamsOverviewPage />} />
        <Route path={routes.STREAM_DETAILS} element={<StreamDetailsPage />} />
        <Route path={routes.MONITORS} element={<MonitorsOverviewPage />} />
        <Route path={routes.MONITOR_DETAILS} element={<MonitorsDetailPage />} />

        <Route path='*' element={<Navigate to={routes.STREAMS} />} />
    </Route>
);

export const router = createHashRouter(routesFromElements);
